import {Injectable} from '@angular/core';
import {Questions} from '../domain/questions';
import {Observable} from "rxjs";
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  private readonly SERVICE_URL = `/api/questions`;

  constructor(private http: HttpClient) {
  }

  public getQuestions(): Observable<Questions[]> {
    return this.http.get<Questions[]>(this.SERVICE_URL);
  }

  public getQuestionsShuffled(): Observable<Questions[]> {
    return this.http.get<Questions[]>(this.SERVICE_URL + "/shuffled");
  }

  public deleteQuestion(question: Questions): Observable<boolean> {
    return this.http.delete<boolean>(this.SERVICE_URL + "/admin/delete/" + question.questionId)
  }

  public updateQuestion(question: Questions): Observable<Questions> {
    let adjustedQuestion = {
      questionId: question.questionId as unknown as number,
      question: question.question,
      answers: question.answers,
      correct_answer: question.correct_answer
    }
    return this.http.patch<Questions>(this.SERVICE_URL + '/admin/update-question', {adjustedQuestion})
  }

  public createQuestion(adjustedQuestion: Questions): Observable<Questions> {
    return this.http.put<Questions>(this.SERVICE_URL + '/admin/create-question', {adjustedQuestion})
  }
}
